<template>
  <div class="promo-analytics-dialog">
    <div class="promo-analytics-dialog__text">
      Чтобы подключить дополнительные услуги свяжитесь с контакт-центром
    </div>

    <div class="promo-analytics-dialog__card">
      <div class="promo-analytics-dialog__phone-icon">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3h3l2 5-2 1c1 3 3 5 6 6l1-2 5 2v3c0 1-1 2-2 2-9 0-16-7-16-16 0-1 1-2 2-2Z"
            fill="#2f84f8"
          />
        </svg>
      </div>
      <div class="promo-analytics-dialog__phone-info">
        <div class="promo-analytics-dialog__phone">
          09388
        </div>
        <div class="promo-analytics-dialog__free-call">
          Бесплатный звонок Мегафон, Билайн, МТС, Yota, Т-Мобайл
        </div>
      </div>
    </div>

    <button class="promo-analytics-dialog__ok" type="button" @click="closeDialog">
      Понятно
    </button>
  </div>
</template>

<script>
import {methodsForDialogMixin} from "@/components/pacs/mixins.js";
export default {
  name: "PromoAnalyticsDialog",
  mixins: [methodsForDialogMixin],
  props: {
    analyticsKey: {type: String, default: ""},
  },
};
</script>

<style lang="scss">
.promo-analytics-dialog {
  width: 330px;
  max-width: 100%;
  background: #fff;
  border-radius: 14px;
  padding: 22px;
}

.promo-analytics-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.promo-analytics-dialog__title {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}

.promo-analytics-dialog__text {
  font-size: 16px;
  line-height: 1.35;
  color: #334155;
  margin-bottom: 18px;
}

.promo-analytics-dialog__card {
  background: #f3f4f6;
  border-radius: 24px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.promo-analytics-dialog__phone-icon {
  flex-shrink: 0;
  margin-left: 35px;
  margin-bottom:12px;
}

.promo-analytics-dialog__phone-info {
  display: flex;
  flex-direction: column;
}

.promo-analytics-dialog__phone {
  font-size: 45px;
  font-weight: 800;
  color: #2f84f8;
  line-height: 1.2;
  margin-top: 20px;
  margin-left: -8px;
  margin-bottom: 10px;
}

.promo-analytics-dialog__free-call {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
  margin-left: -45px;
}

.promo-analytics-dialog__ok {
  width: 100%;
  border: 0;
  background: #2f84f8;
  color: #fff;
  font-weight: 800;
  padding: 8px;
  border-radius: 24px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #1a6ad9;
  }
}
</style>
